import { TableWidget } from "app/components/widget/widget-types/TableWidget";
import { TableTemplateV2 } from "app/components/widget/dashboard/TableTemplate-v2";
import {
    getTableColumns,
    getManagedTableData,
} from "app/pages/app-intelligence/app-analysis/pages/Engagement/components/helpers";
import { i18nFilter } from "app/filters/i18nFilter";
import { getGoogleChartTableConfig } from "app/pages/app-intelligence/app-analysis/pages/Engagement/config/getUsersChartTableConfig";
import type { IAppsEngagementTableColumns } from "app/pages/app-intelligence/app-analysis/pages/Engagement/components/types";

export class AppEngagementOverviewTableWidget extends TableWidget {
    static getWidgetMetadataType() {
        return "AppEngagementOverviewTable";
    }

    static getWidgetResourceType() {
        return "Table";
    }

    static getWidgetDashboardType() {
        return "Table";
    }

    public isPptSupported = () => {
        return false;
    };

    constructor() {
        super();
    }

    get templateUrl() {
        return `/app/components/widget/widget-templates/table.html`;
    }

    get templateComponent() {
        return TableTemplateV2;
    }

    protected getMetricColumnsConfig() {
        const appsMetadata: IAppsEngagementTableColumns[] = this.legendItems.map((item) => {
            return {
                Id: item.id,
                Title: item.name,
            };
        });
        const tableColumns = getTableColumns(appsMetadata, true, undefined);
        return this.filterColumnsByWebSource(tableColumns);
    }

    public reduceRecords(records: any[]): any[] {
        const translate = i18nFilter();
        const managedRecords = getManagedTableData(getGoogleChartTableConfig(), records, translate);
        return managedRecords;
    }
}

AppEngagementOverviewTableWidget.register();
